export class JobRequisitionCandidateInfo {
  id?: number;
  candidateId?: number;
  userId?: number;
  fullName?: number;
}
